"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_TYPES = exports.CLOUDINARY_ROOT_PATH = void 0;
const CLOUDINARY_ROOT_PATH = exports.CLOUDINARY_ROOT_PATH = 'https://res.cloudinary.com/dwr27vxv7/image/upload';
const IMAGE_TYPES = exports.IMAGE_TYPES = {
  jpg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  gif: 'image/gif',
  webm: 'video/webm',
  mp4: 'video/mp4'
};